import { AmlMatchType } from 'further-types/aml';

export const AmlMatchTypeLabels = {
  [AmlMatchType.NameExact]: 'Name Exact',
  [AmlMatchType.AkaExact]: 'Aka Exact',
  [AmlMatchType.NameFuzzy]: 'Name Fuzzy',
  [AmlMatchType.AkaFuzzy]: 'Aka Fuzzy',
  [AmlMatchType.PhoneticName]: 'Phonetic Name',
  [AmlMatchType.PhoneticAka]: 'Phonetic Aka',
  [AmlMatchType.EquivalentName]: 'Equivalent Name',
  [AmlMatchType.EquivalentAka]: 'Equivalent Aka',
  [AmlMatchType.Unknown]: 'Unknown',
  [AmlMatchType.YearOfBirth]: 'Year of Birth',
  [AmlMatchType.RemovedPersonalTitle]: 'Removed Personal Title',
  [AmlMatchType.RemovedPersonalSuffix]: 'Removed Personal Suffix',
  [AmlMatchType.RemovedOrganisationPrefix]: 'Removed Organisation Prefix',
  [AmlMatchType.RemovedOrganisationSuffix]: 'Removed Organisation Suffix',
  [AmlMatchType.RemovedClericalMark]: 'Removed Clerical Mark',
};
